import { useCallback, useEffect, useState } from 'react';
import { useNovelRepository } from './useNovelRepository';

export function useRelationshipEntityTypeFilter(novelId?: string | null) {
  const { novel, updateNovelItem } = useNovelRepository();
  const [hiddenEntityTypeIds, setHiddenEntityTypeIds] = useState<Set<string>>(
    () => new Set(novel.relationshipsHiddenEntityTypeIds || [])
  );

  useEffect(() => {
    setHiddenEntityTypeIds(new Set(novel.relationshipsHiddenEntityTypeIds || []));
  }, [novelId, novel.relationshipsHiddenEntityTypeIds]);

  const persist = useCallback((ids: Set<string>) => {
    void updateNovelItem({ relationshipsHiddenEntityTypeIds: Array.from(ids) });
  }, [updateNovelItem]);

  const toggleEntityType = useCallback((entityTypeId: string) => {
    setHiddenEntityTypeIds((currentIds) => {
      const nextIds = new Set(currentIds);
      if (nextIds.has(entityTypeId)) nextIds.delete(entityTypeId);
      else nextIds.add(entityTypeId);
      persist(nextIds);
      return nextIds;
    });
  }, [persist]);

  const showAllEntityTypes = useCallback(() => {
    const nextIds = new Set<string>();
    setHiddenEntityTypeIds(nextIds);
    persist(nextIds);
  }, [persist]);

  return { hiddenEntityTypeIds, showAllEntityTypes, toggleEntityType };
}